<template>
  <v-alert
    v-if="aviso"
    dense
    text
    :type="aviso.nivel"
    class="banner-vencimiento"
  >
    <div class="d-flex align-center flex-wrap">
      <strong class="mr-4">{{ aviso.texto }}</strong>
      <v-spacer />
      <v-btn small text :color="aviso.nivel" @click="verSuscripcion">
        Ver mi suscripción
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
import suscripcionesService from "@/services/suscripcionesService";
import { rolVeAvisos, textoBannerVencimiento } from "@/utils/avisosVencimiento";

// Aviso de vencimiento/mora del plan para administradores (id_rol 1 y 2). Es informativo: si el resumen
// falla o el rol no corresponde, no se muestra nada y nunca se interrumpe el inicio.
export default {
  name: "BannerVencimiento",

  data() {
    return { resumen: null };
  },

  computed: {
    aviso() {
      return textoBannerVencimiento(this.resumen);
    },
  },

  mounted() {
    this.cargarResumen();
  },

  methods: {
    idRolActual() {
      try {
        const usuario = JSON.parse(localStorage.getItem("token"));
        return usuario ? usuario.id_rol : null;
      } catch (e) {
        return null;
      }
    },

    async cargarResumen() {
      if (!rolVeAvisos(this.idRolActual())) return;
      try {
        this.resumen = await suscripcionesService.getResumen();
      } catch (e) {
        this.resumen = null;
      }
    },

    verSuscripcion() {
      this.$router.push("/mis-suspcripciones").catch(() => {});
    },
  },
};
</script>
